"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenuItem = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../../styles/context");
const use_t_1 = require("use-t");
const Arrow_1 = tslib_1.__importDefault(require("../../../icons/interactive/Arrow"));
const useSyncStore_1 = require("../../../hooks/useSyncStore");
const styles_1 = require("./styles");
const MobileMenuItem = ({ item, onPush, onSelectArgs, onClose }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const active = !!(0, useSyncStore_1.useSyncStoreOpt)(item.active);
    const disabled = !!(0, useSyncStore_1.useSyncStoreOpt)(item.disabled);
    const visibleStore = (0, useSyncStore_1.useSyncStoreOpt)(item.visible);
    if (item.visible && visibleStore === false)
        return null;
    const hasArgs = !!item.params?.length;
    const hasChildren = !!item.children?.length;
    const hasPane = !!item.pane;
    const hasRaw = !!item.raw;
    const navigable = hasChildren || hasPane || hasRaw;
    const display = item.display?.() ?? t(item.name);
    const handleClick = (event) => {
        if (disabled)
            return;
        if (hasArgs) {
            onSelectArgs(item);
            return;
        }
        if (hasPane || hasRaw) {
            onPush(item);
            return;
        }
        if (item.onSelect) {
            item.onSelect(event);
            if (!item.keepOpen)
                onClose();
            return;
        }
        if (hasChildren) {
            onPush(item);
        }
    };
    const danger = !!item.danger;
    const dangerColor = styles.col.get('error', 'el-2');
    const baseColor = styles.g(styles.light ? 0.15 : 0.1);
    const hasControl = !!item.control;
    const rowStyle = {
        color: danger ? dangerColor : baseColor,
        pointerEvents: disabled ? 'none' : undefined,
        opacity: disabled ? 0.45 : 1,
        background: active ? styles.g(0, styles.light ? 0.05 : 0.08) : undefined,
        paddingTop: hasControl ? 10 : undefined,
        paddingBottom: hasControl ? 10 : undefined,
    };
    const description = item.description ? t(item.description) : null;
    const right = item.control?.() ?? item.right?.();
    const noteFn = item.note;
    const keys = item.keys;
    const inert = !item.onSelect && !hasArgs && !hasPane && !hasRaw && !hasChildren;
    let labelEl = display;
    if (item.mono)
        labelEl = React.createElement("code", { style: { fontFamily: 'monospace', fontSize: '.95em' } }, labelEl);
    if (item.more)
        labelEl = (React.createElement("span", null,
            labelEl,
            React.createElement("span", { style: { opacity: 0.4 } }, " \u2026")));
    const Tag = inert ? 'div' : 'button';
    const interactiveProps = inert
        ? {}
        : {
            type: 'button',
            onClick: handleClick,
            disabled,
            role: 'menuitem',
            'aria-haspopup': navigable ? 'menu' : undefined,
            'aria-disabled': disabled || undefined,
        };
    return (React.createElement(Tag, { className: (0, styles_1.itemRowClass)(), style: rowStyle, ...interactiveProps },
        React.createElement("span", { className: styles_1.itemIconClass }, item.icon?.()),
        React.createElement("span", { className: styles_1.itemMainClass },
            React.createElement("span", { className: styles_1.itemLabelClass },
                labelEl,
                noteFn && React.createElement("span", { style: { marginInlineStart: 6, opacity: 0.6 } }, noteFn())),
            description && React.createElement("span", { className: (0, styles_1.itemDescriptionClass)({ col: styles.g(0.5) }) }, description)),
        right && React.createElement("span", { className: styles_1.itemRightClass }, right),
        keys && keys.length > 0 && (React.createElement("span", { className: (0, styles_1.itemKeysClass)({ col: styles.g(0.45) }) }, keys.map((k, i) => (React.createElement("span", { key: i, className: (0, styles_1.keyChipClass)({
                bg: styles.g(0, 0.06),
                col: styles.g(0.4),
            }) }, k))))),
        navigable && !item.onSelect && (React.createElement("span", { className: styles_1.chevronClass, "aria-hidden": "true" },
            React.createElement(Arrow_1.default, { direction: "r", style: { width: 16, height: 16 } })))));
};
exports.MobileMenuItem = MobileMenuItem;
